// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rasa-checkbox {\r\n  width: 34px;\r\n  height: 34px;\r\n  border-radius: 5px;\r\n  background-color: #EAF7F6;\r\n}\r\n.rasa-checkbox i {\r\n  color: #53B7AE;\r\n}", ""]);
// Exports
module.exports = exports;
